const BaseView = require('components-framework/view/base.view');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const tracking = require('od-modules/checkin/tracking');
const modalWindow = require('od-modules/checkin/ui/modal');

module.exports = withCachedSelectors(BaseView.extend({

    showCheckinMoreInfoNag() {
        if (Odigeo.AB.isShowCheckinMoreInfoNagEnabled) {
            this.createModalWindows();
            this.moreInfoModal.open();
            tracking.trackOnloadCheckinMoreInfoNag();
        }
    },

    startCheckinFunnelPopup() {
        if (Odigeo.AB.isCheckinSBV3Enabled) {
            const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
            window.location.href = `/travel/extras/#checkin/info/${tdToken}/`;
        } else {
            Odigeo.trigger(`${this.name}:startCheckinFunnelPopup`);
        }
    },

    createModalWindows() {
        const parentEl = document.body;
        this.moreInfoModal = modalWindow.factory({
            parentEl,
            contents: this.templates.modalMoreinfo(this),
            onAccept: () => this.onAcceptNotification(this.moreInfoModal),
            onClose: () => this.onRejectNotification(this.moreInfoModal),
        });
    },

    onRejectNotification(modal) {
        modal.close();
        tracking.trackClickCheckinMoreInfoNag('close');
    },

    onAcceptNotification(modal) {
        modal.close();
        this.startCheckinFunnelPopup();
        tracking.trackClickCheckinMoreInfoNag('click');
    },

}));
